import { RoleVO } from '../../vo/user/role.vo';
import { ProfileVO } from '../../vo/user/profile.vo';
import { Component, ChangeDetectionStrategy, ElementRef, ChangeDetectorRef } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

type ROLE_OR_PROFILE = RoleVO | ProfileVO;

@Component({
  selector: 'role-or-profile-renderer',
  template: `<wiz-hgroup height="100%" width="100%" gap="5" verticalAlign="center">
    <wiz-icon width="18" height="18" style="font-size: 18px;" *ngIf="canCreate" [wizTooltip]="'$.role.kind.c.$'">creation</wiz-icon>
    <wiz-icon width="18" height="18" style="font-size: 18px;" *ngIf="canRead" [wizTooltip]="'$.role.kind.r.$'">see</wiz-icon>
    <wiz-icon width="18" height="18" style="font-size: 18px;" *ngIf="canUpdate" [wizTooltip]="'$.role.kind.u.$'">edit</wiz-icon>
    <wiz-icon width="18" height="18" style="font-size: 18px;" *ngIf="canDelete" [wizTooltip]="'$.role.kind.d.$'">delete</wiz-icon>
  </wiz-hgroup> `,
  styles: [':host {height:100%; width: 100%;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoleAccessRenderer implements AgRendererComponent {
  data: ROLE_OR_PROFILE;
  params: any;

  constructor(public elementRef: ElementRef, private cdref: ChangeDetectorRef) {}

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }
  agInit(params: ICellRendererParams): void {
    this.data = params.data;
    this.params = params;
    this.cdref.markForCheck();
  }

  get canRead(): boolean {
    return this.checkProperty('doRead');
  }

  get canUpdate(): boolean {
    return this.checkProperty('doUpdate');
  }

  get canDelete(): boolean {
    return this.checkProperty('doDelete');
  }

  get canCreate(): boolean {
    return this.checkProperty('doCreate');
  }

  private checkProperty(prop: string) {
    if (this.data instanceof RoleVO) {
      return this.data[prop];
    } else {
      if (!!this.data.rolesVO) {
        return this.data.rolesVO.filter((r) => r[prop]).length > 0;
      }
    }

    return false;
  }
}
